import { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { baseURL, basics } from "../../../basics";
import { userInfoActions } from "../../../store/userInfo-slice";
import logo from "../../../resources/images/app/ic_icon.png";
import { uiActions } from "../../../store/Ui-slice";
import { CgProfile } from "react-icons/cg";
import { AiFillCamera } from "react-icons/ai";
import MainModal from "./MainModal";
import axios from "axios";

const AddCommentToStore = () => {
  const dispatch = useDispatch();
  const [inputValue, setInputValue] = useState("");
  const [yourCommentIsEmpty, setYourCommentIsEmpty] = useState(false);
  const [addComment, setAddComment] = useState(false);
  const Token = useSelector((state: any) => state.auth.token);
  const storeId = useSelector((state: any) => state.shopInfo.storeId);
  const loggedIn = useSelector((state: any) => state.auth.isLoggedIn);
  const descriptionInputRef = useRef<HTMLTextAreaElement>(null);
  // const parentCommentId = ;
  const addCommentButtonHandler = (event: any) => {
    event.preventDefault();
    if (loggedIn) {
      setAddComment(true);
    } else {
      dispatch(uiActions.toggleModal());
    }
  };
  const sendCommentHandler = (event: any) => {
    event.preventDefault();
    //console.log('sendCommentHandler');
    //     useEffect(() => {
    const enteredDescription = descriptionInputRef.current!.value;
    if (enteredDescription) {
      setYourCommentIsEmpty(false);
      const bodyFormData = new FormData();
      bodyFormData.append("storeId", storeId);
      // bodyFormData.append("parentCommentId", parentCommentId);
      bodyFormData.append("description", enteredDescription);
      //     //console.log("sendfavoriteCartData", id);
      // console.log("sendCommentHandler", enteredDescription);
      dispatch(
        uiActions.showNotification({
          status: "pending",
          title: "در حال ارسال  ",
          message: "در حال ارسال نظر شما ",
        })
      );
      axios({
        method: "post",
        url: `${baseURL}api/General/AddCommentToStore?access_token=${Token}`,
        data: bodyFormData,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((response: any) => {
          // console.log("response sendCommentHandler", response);
          dispatch(
            uiActions.showNotification({
              status: "success",
              title: "نظر شما ارسال شد",
              message:
                "نظر شما پس از تایید توسط مدیر فروشگاه در لیست نظرات و پیشنهادات نمایش داده خواهد شد",
            })
          );
          setInputValue("");
          //console.log("response POST", response);
          //     const data = response.data.data;
          //     setServerData(data);
        })
        .catch((error: any) => {
          //console.log("response POST", error);
          dispatch(
            uiActions.showNotification({
              status: "error",
              title: "نظر شما ارسال نشد",
              message: "متاسفانه نظر شما ارسال نشد. لطفا دوباره اقدام کنید",
            })
          );
        });
      //     }, [description, id]);
    } else {
      setYourCommentIsEmpty(true);
      setTimeout(() => setYourCommentIsEmpty(false), 2000);
    }
  };
  const ButtonCss = inputValue? 'bg-rose-600': 'bg-rose-300'
  return (
    <MainModal>
      <div className="bg-zinc-50 flex flex-col justify-center items-center rounded-lg p-2 min-h-full w-72 sm:w-96 space-y-8">
        <div>
          <p className="font-bold">{basics.userCommentTitle}</p>
        </div>
        <div className="flex justify-center w-full">
          {/* {!addComment && (
        <button
          onClick={addCommentButtonHandler}
          className="w-full p-1 mb-1 text-zinc-50 cursor-pointer bg-gray-700 rounded-lg flex justify-center items-center "
        >
          {basics.addComment}
        </button>
      )} */}
          {/* {addComment && ( */}
          <form
            action="#"
            className="flex flex-col justify-center items-center w-full rounded-lg p-1"
          >
            <textarea
             id="descriptionOfcomment"
              ref={descriptionInputRef}
              className="p-1 h-24 w-full max-w-20 bg-zinc-50 border-2 border-gray-200 rounded shadow-md"
              placeholder="نظر خود را بنویسید"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              required
            />
            <button
              className={`${ButtonCss} w-24 h-10 text-zinc-50 rounded-lg cursor-pointer flex justify-center items-center m-2`}
              onClick={sendCommentHandler}
            >
              {basics.addComment}
            </button>
            {/* {typedComment > 3 ? ( */}
          </form>
          {/* )} */}

          {/* ) : ( */}
          {/* <div className="bg-rose-500 text-zinc-50 my-1 p-1 rounded-l"> */}
          {/* ثبت نظر */}
          {/* </div> */}
          {/* )} */}
        </div>
      </div>
    </MainModal>
  );
};

export default AddCommentToStore;
